const Sdata = [
    {
        title:"ReactJS Developer - Full Stack Developer (Australian Company)",
        company:"CIMET",
        location:"Jaipur, Rajasthan"
    },
    {
        title:"Backend Developer",
        company:"Macayla Education & Placement Services",
        location:"Jaipur, Rajasthan"
    },
    {
        title:"Web designer",
        company:"UWS (India)",
        location:"Jaipur, Rajasthan"
    },
    {
        title:"Frontend developer",
        company:"Vacancy Factor",
        location:"Jaipur, Rajasthan"
    },
    {
        title:"Graphics designer",
        company:"OXO Solutions",
        location:"Amer"
    },
    {
        title:"Full Stack Developer",
        company:"Gempulse Infotech",
        location:"Jaipur, Rajasthan"
    },
]

export default Sdata;